<template>
  <v-container id="page-group-list">
    <div class="page-title">{{ $route.name }}</div>

    <v-row justify="end">
      <div class="mr-5" style="width: 250px">
        <v-text-field
          v-model="searchKeyword"
          label="그룹명 검색"
          prepend-icon="search"
          maxlength="32"
          @keyup="onSearch"
        ></v-text-field>
      </div>
    </v-row>

    <c-table
      :headers="groupTableHeaders"
      itemKey="id"
      :items="groupList"
      :page="pagination.page"
      :itemsPerPage="pagination.size"
      :totalElements="totalElements"
      @update:tableOptions="updateOption"
    >
      <template #type="{ item }">
        {{ item.type ? item.type.configName : "가족" }}
      </template>
      <template #created="{item}">
        {{ $func.dateToString(item.created) }}
      </template>
      <template #detail="{ item }">
        <c-btn icon iconName="search" @click="onMoveDetail(item)" />
      </template>
    </c-table>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    searchKeyword: "",
    filterItem: "그룹명",

    groupList: [],

    groupTableHeaders: [
      {
        text: "그룹명",
        value: "name",
        align: "center",
        sortable: true,
      },
      {
        text: "그룹 유형",
        value: "type",
        align: "center",
        sortable: true,
      },
      {
        text: "등록일",
        value: "created",
        align: "center",
        sortable: true,
      },
      {
        text: "소속 회원 수",
        value: "memberCnt",
        align: "center",
        sortable: true,
      },
      {
        text: "상세보기",
        value: "detail",
        align: "center",
        sortable: false,
      },
    ],
    pagination: {
      page: 1,
      size: 10,
      sort: "name,desc",
    },
    totalElements: 0,
  }),
  activated() {
    this.reqGetGroupList();
  },
  watch: {},
  methods: {
    async reqGetGroupList() {
      try {
        const res = await this.$api.getGroupList({
          ...this.pagination,
          searchKeyword: this.searchKeyword,
        });
        this.groupList = res.data.content;
        this.totalElements = res.data.totalElements;
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqGetGroupList" });
      }
    },
    onMoveDetail(item) {
      this.$router.push(`/group/${item.id}`);
    },
    updateOption(option) {
      this.pagination.page = option.page;
      this.pagination.size = option.itemsPerPage;
      if (option.sortBy.length > 0 && option.sortDesc.length > 0) {
        this.pagination.sort = `${option.sortBy[0]},${
          option.sortDesc[0] ? "asc" : "desc"
        }`;
      }
      this.reqGetGroupList();
    },
    onSearch(event) {
      if (event.key === "Enter") {
        this.pagination.page = 1;
        this.reqGetGroupList();
      } else {
        return;
      }
    },
  },
};
</script>

<style scoped></style>
